import React from "react";
import { Card, Box, Flex, Grid, Text, Heading } from "@radix-ui/themes";
import { SummaryType } from "../../../types/TeacherEvaluation";

interface TeacherEvaluationSummaryProps {
  summary: SummaryType;
}

const TeacherEvaluationSummary: React.FC<TeacherEvaluationSummaryProps> = ({ summary }) => {
  const summaryItems = [
    { 
      label: "Total de Avaliações", 
      value: summary?.totalEvaluations?.toLocaleString(),
      icon: "📊"
    },
    { 
      label: "Média", 
      value: summary?.averageClassification?.toFixed(2),
      icon: "⭐"
    },
    { 
      label: "Classificação Máxima", 
      value: summary?.maxClassification?.toString(),
      icon: "🔝"
    },
    { 
      label: "Classificação Mínima", 
      value: summary?.minClassification?.toString(),
      icon: "⬇️"
    }
  ];

  return (
    <Box>
      <Heading 
        as="h3" 
        size="3" 
        weight="bold" 
        mb="4" 
        align="center"
      >
        Resumo Geral da Avaliação
      </Heading>

      <Grid 
        columns={{ initial: "1", sm: "2", md: "4" }} 
        gap="3"
      >
        {summaryItems?.map(({ label, value, icon }) => (
          <Card key={label} variant="surface">
            <Flex gap="3" align="center">
              <Text size="6">{icon}</Text>
              <Box>
                <Text 
                  as="div" 
                  size="2" 
                  color="gray" 
                  mb="1"
                >
                  {label}
                </Text>
                <Text 
                  as="div" 
                  size="4" 
                  weight="bold"
                >
                  {value}
                </Text>
              </Box>
            </Flex>
          </Card>
        ))}
      </Grid>
    </Box>
  );
};

export default TeacherEvaluationSummary;